export const AUTH_SYNC_CHANNEL_NAME = 'whatyouwish.auth';
export const AUTH_SYNC_STORAGE_KEY = 'whatyouwish.auth.event';
export const LOGOUT_EVENT = Object.freeze({
  type: 'logout',
  version: 1
});

const createChannel = () => {
  if (typeof window === 'undefined' || typeof window.BroadcastChannel !== 'function') {
    return null;
  }

  return new window.BroadcastChannel(AUTH_SYNC_CHANNEL_NAME);
};

const getLocalStorage = () => {
  try {
    return typeof window === 'undefined' ? null : window.localStorage;
  } catch {
    return null;
  }
};

const isLogoutEvent = (event) => (
  event?.type === LOGOUT_EVENT.type && event?.version === LOGOUT_EVENT.version
);

export const publishLogout = ({
  channelFactory = createChannel,
  storage = getLocalStorage()
} = {}) => {
  const channel = channelFactory();

  if (channel) {
    channel.postMessage(LOGOUT_EVENT);
    channel.close();
    return true;
  }

  if (!storage) {
    return false;
  }

  try {
    storage.setItem(AUTH_SYNC_STORAGE_KEY, JSON.stringify(LOGOUT_EVENT));
    storage.removeItem(AUTH_SYNC_STORAGE_KEY);
    return true;
  } catch {
    return false;
  }
};

export const subscribeToLogout = (onLogout, {
  channelFactory = createChannel,
  eventTarget = typeof window === 'undefined' ? null : window
} = {}) => {
  const channel = channelFactory();

  if (channel) {
    channel.onmessage = ({ data }) => {
      if (isLogoutEvent(data)) {
        onLogout();
      }
    };

    return () => channel.close();
  }

  if (!eventTarget) {
    return () => {};
  }

  const onStorage = (event) => {
    if (event.key !== AUTH_SYNC_STORAGE_KEY || !event.newValue) {
      return;
    }

    try {
      if (isLogoutEvent(JSON.parse(event.newValue))) {
        onLogout();
      }
    } catch {
      // Ignore malformed messages from unrelated or older clients.
    }
  };

  eventTarget.addEventListener('storage', onStorage);
  return () => eventTarget.removeEventListener('storage', onStorage);
};
